import styled from "styled-components";

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 20px;
  padding: 35px 35px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.02);
  overflow-y: auto;
  color: #4a4a4a;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #e0e0e0;
    border-radius: 4px;
  }
`;

export const Header = styled.div`
  margin-bottom: 20px;

  .title {
    font-size: 25px;
    font-family: "Nunito Sans Light";
    color: #1f1f52;
    margin: 0;
    font-weight: 400;
    display: flex;
    align-items: center;

    i {
      font-size: 18px;
    }
  }
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 17px;

  p {
    margin: 0;
  }

  .type {
    color: #3e3e5b;
    strong {
      font-weight: 600;
    }
  }

  .subtype {
    color: #707582;
    margin-top: -10px;
  }

  .registered {
    color: #707582;
  }

  .resolve-date {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 5px;
    color: #3e3e5b;
    font-size: 16px;

    .date-pill {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: #f2f2f7;
      padding: 6px 14px;
      border-radius: 12px;
      font-size: 13px;
      color: #707582;
      width: fit-content;

      i {
        font-size: 11px;
        font-style: normal;
        color: #1f1f52;
      }

      .word {
        color: #1f1f52;
      }
    }
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: #efefef;
  margin: 20px 0;
`;

export const BodyText = styled.div`
  flex: 1;
  font-size: 16px;
  line-height: 1.6;
  color: #384260;
  overflow: auto;

  p {
    margin: 0;
  }
`;

export const EditForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex: 1;

  .select-container {
    background: #f4f5fa;
    border-radius: 15px;
    padding: 12px 18px;
    position: relative;

    label {
      font-size: 13px;
      color: #404b69;
      display: flex;
      align-items: center;
      gap: 8px;

      i {
        font-size: 10px;
        color: #404b69;
        font-style: normal;
      }
    }

    .value-text {
      color: #2d39c4;
      font-size: 14px;
      margin-top: 5px;
    }

    .select-arrow-bg {
      position: absolute;
      right: 18px;
      top: 50%;
      transform: translateY(-50%);
      background: #ffffff;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.03);

      i {
        font-size: 12px;
        color: #404b69;
        font-style: normal;
      }
    }
  }

  .severity-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;

    label {
      font-size: 16px;
      color: #616f8c;
    }

    .severity-selector {
      display: flex;
      border: 1px solid #4aa3f0;
      border-radius: 25px;
      overflow: hidden;
      background: #fafafa;
      padding: 0;
      height: 45px;

      .severity-option {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        color: #404b69;
        cursor: pointer;
        transition: all 0.2s;

        &.active {
          background: #fcaf38;
          color: #ffffff;
          border-radius: 25px;
          margin: 2px;
        }

        &:not(.active):hover {
          background: #f0f2ff;
        }
      }
    }
  }

  .textarea-container {
    margin-top: 10px;
    position: relative;
    border: 1px solid #eaefea;
    border-radius: 20px;
    padding: 20px;
    flex: 1;
    display: flex;
    min-height: 180px;

    textarea {
      flex: 1;
      width: 100%;
      border: none;
      outline: none;
      resize: none;
      font-family: inherit;
      font-size: 15px;
      color: #404b69;
      line-height: 1.6;
    }

    .mic-btn {
      position: absolute;
      bottom: 20px;
      right: 20px;
      background: #2d39c4;
      color: #ffffff;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      box-shadow: 0px 4px 10px rgba(45, 57, 196, 0.3);

      i {
        font-style: normal;
        font-size: 20px;
      }

      &:hover {
        background: #252fa1;
      }
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;

  .cancel-btn {
    background: #f0f2ff;
    color: #2d39c4;
    border: none;
    border-radius: 20px;
    padding: 10px 24px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background: #e8ebfe;
    }
  }

  .actions {
    display: flex;
    align-items: center;
    gap: 15px;

    .icon-btn {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: #f0f2ff;
      color: #4b5282;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 18px;
      transition: background 0.2s;
      font-style: normal;

      i {
        font-style: normal;
      }

      &:hover {
        background: #e8ebfe;
      }
    }

    .complete-btn {
      background: #00a300;
      color: #ffffff;
      border: none;
      border-radius: 25px;
      padding: 10px 24px;
      font-size: 15px;
      font-weight: 500;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 10px;
      transition: background 0.2s;

      &:hover {
        background: #008700;
      }

      span {
        font-weight: bold;
        font-size: 16px;
      }
    }

    .save-btn {
      background: #2d39c4;
      color: #ffffff;
      border: none;
      border-radius: 25px;
      padding: 10px 24px;
      font-size: 15px;
      font-weight: 500;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 10px;
      transition: background 0.2s;
      box-shadow: 0px 4px 10px rgba(45, 57, 196, 0.2);

      &:hover {
        background: #252fa1;
      }

      span {
        font-weight: bold;
        font-size: 16px;
      }
    }
  }
`;
